module.exports = __webpack_public_path__ + "media/icons/osoba-prywatna-unactive-64d53ce3.png";